// extracted by mini-css-extract-plugin
export default {"subTitle":"TabQuattro_subTitle__E3zSt","title":"TabQuattro_title__shiyU","textField":"TabQuattro_textField__gjj-w","disabledTextField":"TabQuattro_disabledTextField__wDOD8"};